var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 24,
    viewBox: "0 0 175 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7977_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0199 23.6505H3.24663C1.92947 23.6505 0.752644 22.86 0.248607 21.6367C-0.255431 20.4134 0.0207218 19.0178 0.952119 18.0817L13.9556 5.00971H4.63576C2.0755 5.00971 1.9627e-06 2.92327 1.9627e-06 0.349515H17.313C18.6301 0.349515 19.8069 1.13979 20.311 2.36309C20.8151 3.58639 20.5391 4.98172 19.6078 5.91831L6.60427 18.9903H17.3841C19.9444 18.9903 22.0199 21.0767 22.0199 23.6505ZM105 9.08738C105 4.07653 100.945 0 95.9603 0C93.294 0 90.8944 1.1671 89.2384 3.019C87.5824 1.1671 85.1828 0 82.5166 0C77.532 0 73.4768 4.07653 73.4768 9.08738V23.6505C76.0371 23.6505 78.1126 21.564 78.1126 18.9903V9.08738C78.1126 6.64624 80.0882 4.66019 82.5166 4.66019C84.9449 4.66019 86.9205 6.64624 86.9205 9.08738V18.9903C86.9205 21.564 88.996 23.6505 91.5563 23.6505V9.08738C91.5563 6.64624 93.5319 4.66019 95.9603 4.66019C98.3886 4.66019 100.364 6.64624 100.364 9.08738V18.9903C100.364 21.564 102.44 23.6505 105 23.6505L105 9.08738ZM71.1589 12C71.1589 18.6274 65.8145 24 59.2219 24C52.6292 24 47.2848 18.6274 47.2848 12C47.2848 5.37258 52.6292 0 59.2219 0C65.8145 0 71.1589 5.37258 71.1589 12ZM66.5232 12C66.5232 7.94634 63.2543 4.66019 59.2219 4.66019C55.1894 4.66019 51.9205 7.94634 51.9205 12C51.9205 16.0537 55.1894 19.3398 59.2219 19.3398C63.2543 19.3398 66.5232 16.0537 66.5232 12ZM45.4305 12C45.4305 18.6274 40.0861 24 33.4934 24C26.9007 24 21.5563 18.6274 21.5563 12C21.5563 5.37258 26.9007 0 33.4934 0C40.086 0 45.4305 5.37258 45.4305 12ZM40.7947 12C40.7947 7.94634 37.5258 4.66019 33.4934 4.66019C29.461 4.66019 26.1921 7.94634 26.1921 12C26.1921 16.0537 29.461 19.3398 33.4934 19.3398C37.5258 19.3398 40.7947 16.0537 40.7947 12Z",
    fill: "#0B5CFF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    width: 60,
    height: 24,
    rx: 4,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.776 20V3.2H124.792V18.392H132.616V20H122.776ZM135.385 20V3.2H137.401V20H135.385ZM146.028 20L139.716 3.2H141.9L147.204 17.864L152.556 3.2H154.692L148.38 20H146.028ZM156.995 20V3.2H167.387V4.856H159.011V10.712H166.667V12.344H159.011V18.344H167.387V20H156.995Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7977_330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomLive);
export default __webpack_public_path__ + "static/media/zoom-live.297f89f711f76ddcbbe5b48b783aceb2.svg";
export { ForwardRef as ReactComponent };